import React from 'react';
import { Box, Paper, Button, useTheme, useMediaQuery } from '@mui/material';
import DirectionsIcon from '@mui/icons-material/Directions';

const GoogleMap = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  // Replace this URL with your specific location's embed URL from Google Maps
  const mapUrl = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3173.124471556304!2d-122.03379242349752!3d37.315879172104744!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fb5075fd76ac9%3A0x759d2244a3fbe182!2s20480%20Pacifica%20Dr%20d%2C%20Cupertino%2C%20CA%2095014!5e0!3m2!1sen!2sus!4v1743045636459!5m2!1sen!";
  
  const handleDirections = () => {
    const address = "20480 Pacifica Dr d Cupertino CA 95014";
    const encodedAddress = encodeURIComponent(address);
    
    // Check if the user is on a mobile device
    const isMobileDevice = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    
    if (isMobileDevice) {
      // Try to open in Google Maps app first
      window.location.href = `comgooglemaps://?daddr=${encodedAddress}`;
      
      // Fallback to web version after a short delay if the app doesn't open
      setTimeout(() => {
        window.location.href = `https://www.google.com/maps/dir/?api=1&destination=${encodedAddress}`;
      }, 2000);
    } else {
      // For desktop, open in new tab
      window.open(`https://www.google.com/maps/dir/?api=1&destination=${encodedAddress}`, '_blank');
    }
  };

  return (
    <Box sx={{ position: 'relative', width: '100%' }}>
      <Paper 
        elevation={3} 
        sx={{ 
          width: '100%', 
          height: { xs: '300px', md: '400px' },
          overflow: 'hidden',
          borderRadius: 2,
        }}
      >
        <iframe
          src={mapUrl}
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Dental Clinic Location Map"
        />
      </Paper>
      <Button
        variant="contained"
        color="primary"
        startIcon={<DirectionsIcon />}
        onClick={handleDirections}
        sx={{
          position: 'absolute',
          bottom: 16,
          right: 16,
          zIndex: 1,
          borderRadius: '20px',
          px: 3,
          py: 1,
          boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
          '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
          },
          transition: 'all 0.2s ease-in-out',
        }}
      >
        {isMobile ? 'Directions' : 'Get Directions'}
      </Button>
    </Box>
  );
};

export default GoogleMap; 